// Layout
import LabelLayout from './LabelLayout'
import LabelTemplate from './LabelTemplate'

// Pages
import LabelListPage from './pages/LabelListPage'
import LabelCreatePage from './pages/LabelCreatePage'
import LabelEditPage from './pages/LabelEditPage'

export const labelRoutes = (prefix = "label") => [
  {
    path: prefix,
    component: LabelLayout,
    children: [
      {
        path: '',
        redirect: `${prefix}/list`
      },
      {
        path: '',
        component: LabelTemplate,
        children: [
          {
            name: "LabelList",
            path: 'list',
            component: LabelListPage
          },
          {
            name: "LabelCreate",
            path: 'create',
            component: LabelCreatePage
          },
          {
            name: "LabelEdit",
            path: 'edit/:id',
            component: LabelEditPage,
            props: (route) => ({
              id: route.params.id
            })
          }
        ]
      }
    ]
  }
];